( function( $, document ) {
    'use strict';

    $( document ).ready( function() {

    } );

} )( jQuery, document );
